import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon, BadgeCheckIcon } from 'lucide-react';
import { buyers, images } from '../data/content';
type Notice = {
  name: string;
  place: string;
  minutes: number;
};
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let showTimer: number;
    let hideTimer: number;
    const show = () => {
      const buyer = buyers[index % buyers.length];
      index += 1;
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => {
        setNotice(null);
        showTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[340px] sm:bottom-28 sm:left-5" data-id="element-344" data-mp="114th5y1nd670">
      <AnimatePresence data-id="element-345" data-mp="1awz7728c9djk">
        {notice && !dismissed && <motion.div key={notice.name} role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_18px_40px_-16px_rgba(11,29,51,0.45)]" data-id="element-346" data-mp="1aysiiutwclxw">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-sand object-contain" data-id="element-347" data-mp="28mki1vgffz8n" />
            <div className="min-w-0" data-id="element-348" data-mp="23npobygx8q9r">
              <p className="text-sm leading-snug text-ink" data-id="element-349" data-mp="2apcrmzy5v1hx">
                <strong data-id="element-350" data-mp="2aqxk8k0x0ad5">{notice.name}</strong> from {notice.place}
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-351" data-mp="2flthbyl0dnx4">
                <ShoppingBagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-352" data-mp="2kniqt9sl1tj3" />
                just bought this digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-muted" data-id="element-353" data-mp="1rybvsksc7m2l">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-354" data-mp="1wx6apbn6oqhf" />
                Verified · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 grid h-6 w-6 place-items-center rounded-full text-muted transition-colors duration-150 hover:bg-sand hover:text-ink" aria-label="Dismiss notification" data-id="element-355" data-mp="21uyep413s31z">
              <XIcon className="h-3.5 w-3.5" data-id="element-356" data-mp="3rgyexi6nccf3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}